import { useState } from 'react'

import DialogTitle from '@mui/material/DialogTitle'
import Dialog from '@mui/material/Dialog'
import CloseIcon from '@mui/icons-material/Close'
import { DialogActions, DialogContent, IconButton, TextField } from '@mui/material'

import '../../../pptos/anular/dialogApprove.css'
import { Model } from '../../../../models/model'
import { Link } from 'react-router-dom'
import { Templates } from './Templates'

export const DialogTemplates = ({ open, setOpen, detailBudget, detailTasks, handleAddTaskFromTemplates }) => {

    const [msgError, setMsgError] = useState('')
    const [openTemplates, setOpenTemplates] = useState(false)

    const [form, setForm] = useState({
        nombre: `Tareas para ${detailBudget?.area_negocio}`
    })

    const handleSave = async () => {
        if (form.nombre === '') {
            setMsgError('Falta ingresar nombre')
            return false
        }

        if (detailTasks?.length === 0) {
            setMsgError('No hay tareas para guardar plantilla')
            return false
        }

        const dataForm = {
            nombre: form.nombre,
            id_ppto_origen: detailBudget?.id,
            id_area_negocio: detailBudget?.id_area_negocio,
            detalle_plantilla: detailTasks
        }

        const result = await Model.save({
            url: 'tasks/templates',
            dataForm: dataForm,
            resultData: true
        })

        console.log('--result save--', result)
        setOpen(false)
    }

    const handleChange = ({ target }) => {
        setForm({
            ...form,
            nombre: target.value
        })
    }

    return (
        <>

            <Dialog
                onClose={() => setOpen(false)}
                open={open}
                className='p-dialog-approve'
            >
                <DialogTitle className='ColorTitleDocument' id="scroll-dialog-title">
                    <IconButton
                        aria-label="close"
                        style={{ padding: '0', float: 'right' }}
                        onClick={() => setOpen(false)}
                    >
                        <CloseIcon
                            style={{ color: '#78667E' }}
                        />
                    </IconButton>
                </DialogTitle>
                <DialogContent className='content'>

                    <div className='d-flex justify-content-center p-icons align-items-center'>
                        <i className="bi bi-file-earmark-ruled" style={{ fontSize: '50px', color: '#909090' }}></i>
                        <i className="bi bi-arrow-right ms-2 me-2" style={{ fontSize: '30px', color: '#909090' }}></i>
                        <i className="bi bi-file-earmark-ruled" style={{ fontSize: '50px', color: '#909090' }}></i>
                    </div>

                    <div className='text'>
                        <h3>Guardar plantilla de tareas</h3>
                    </div>

                    <div className='p-text-comments2 mt-4'>
                        <TextField
                            label="Nombre de la plantilla"
                            name="referencia"
                            id="outlined-size-small"
                            value={form.nombre || ''}
                            size="small"
                            fullWidth
                            placeholder='Ingrese nombre de la plantilla'
                            onChange={handleChange}
                        />
                    </div>

                    {msgError !== '' &&
                        <p style={{ color: 'red', textAlign: 'center', fontSize: '14px', marginTop: '5px' }}>{msgError}</p>
                    }

                </DialogContent>
                <DialogActions className='d-flex justify-content-between mt-3 mb-2 p-actions'>
                    <button className='approve ms-3' onClick={handleSave}>Guardar</button>
                    <Link to="" onClick={() => setOpenTemplates(true)} className='me-3 p-links'>Ver lista</Link>
                </DialogActions>
            </Dialog>

            {openTemplates &&
                <Templates
                    open={openTemplates}
                    setOpen={setOpenTemplates}
                    createFrom={handleAddTaskFromTemplates}
                />
            }

        </>
    );

}